import ObjectBrowser, { ObjectType } from '../../components/ObjectBrowser/ObjectBrowser';
import { Api } from '../../App';
import '../Steps.css';

function MaterialStep({step, dispatchStep}:any) {
    return (
        <ObjectBrowser
            style={{display: step === 1 ? 'flex' : 'none'}}
            type={ObjectType.MATERIAL}
            searchPlaceholder="materials by name, description..."
            objects={Api.getMaterialsAsObjects()}
            changeStep={dispatchStep}
            filters={[{
            name: 'Material Group',
            type: 'radio',
            filters: 'machining_group',
            options: Api.getMaterialGroupsAsOptions()
            }, "Select a material or material group."]}
        />
    )
}

export default MaterialStep;